import { render, staticRenderFns } from "./GlobalLoadingBar.vue?vue&type=template&id=5ec13654&scoped=true"
import script from "./GlobalLoadingBar.vue?vue&type=script&lang=js"
export * from "./GlobalLoadingBar.vue?vue&type=script&lang=js"
import style0 from "./GlobalLoadingBar.vue?vue&type=style&index=0&id=5ec13654&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec13654",
  null
  
)

export default component.exports